import React, { useState, useEffect, useRef, useCallback } from 'react';
import { FlatList, StyleSheet, SafeAreaView, View, Platform, useWindowDimensions, TouchableOpacity } from 'react-native'
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../../components/CustomButton/CustomButton';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import { ActivityIndicator, Card } from 'react-native-paper';
import { useAuthContext } from "../../../../hooks/useAuthContext";
import AddNewDocumentScreen from "./HRAdminAddNewDocumentScreen"
import axios from 'axios';
import { showMessage } from "react-native-flash-message";
import Ionicons from "@react-native-vector-icons/ionicons/static";
import Swal from 'sweetalert2';

export default function HRAdminDocumentsScreen({ selectedCompany }) {
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions()
    const { colors } = useTheme()
    const styles = makeStyles(colors, height, width);
    const common = createCommonStyles(colors);
    const [loading, setLoading] = useState(true);
    const { user, clientApi } = useAuthContext();
    const [addNewDocument, setAddNewDocument] = useState(0);
    const [editDocumentScreen, setEditDocumentScreen] = useState(0);
    const [removeDocumentScreen, setRemoveDocumentScreen] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const [addDocExist, setAddDocExist] = useState(false);
    let documents_arr = [];
    const [documents, setDocuments] = useState([])
    const [documentForEdit, setDocumentForEdit] = useState();
    // const [buttonRendered, setButtonRendered] = useState(false);


    const getDocuments = async (server_ip, token) => {
        if (selectedCompany === null) return [];
        try {
            var fetchCmd = server_ip + "api/Company/Documents";
            const response = await axios.get(fetchCmd, {
                headers: { Authorization: `Bearer ${token}` },
                params: { company: selectedCompany }
            });
            return response.data;
        } catch (error) {
            console.log(error)
            throw new Error(error)
        }
    }

    const deleteDocuments = async (server_ip, rowguid) => {
        try {
            var fetchCmd = server_ip + "api/Company/Documents";
            const response = await axios.delete(fetchCmd, {
                headers: { Authorization: `Bearer ${user.token}` },
                params: { docrowguid: rowguid }
            });
            return response.data;
        } catch (error) {
            console.log(error)
            throw new Error(error)
        }
    }

    useEffect(() => {
        getDocuments(clientApi, user.token).then((data) => {
            let objUri;
            data.forEach((obj, index) => {
                setLoading(true);
                if (obj.type === 'pdf')
                    objUri = `data:application/pdf;base64,${obj.data}`
                else if (obj.type === 'png' || obj.type === 'jpg')
                    objUri = `data:image/${obj.type};base64,${obj.data}`
                documents_arr.push({ name: obj.name, id: index + "" + obj.name, uri: objUri, rowguid: obj.id, type: obj.type });
            });
            setDocuments(documents_arr)
            setLoading(false);

        })
            .catch((err) => {
                console.log(err.message);
            });

    }, [selectedCompany]);

    const renderItem = ({ item }) => {
        return (
            <Card
                style={common.cardstyle} >
                <Card.Content>
                    <SurveyListView {...item} />
                </Card.Content>
            </Card >
        )
    };

    const removeDocument = (item) => {
        deleteDocuments(clientApi, item.rowguid).then((response) => {
        })
        const docsNew = documents.filter((doc) => doc.rowguid !== item.rowguid);
        setDocuments([...docsNew])
        setModalVisible(false);
    };

    const editDocument = (document) => {
        setAddDocExist(true);
        setDocumentForEdit(document);
        setEditDocumentScreen(1);
        setAddNewDocument(0);
        setRemoveDocumentScreen(0);
    };

    const SurveyListView = (item) => {
        return (
            <SafeAreaView
                style={styles.row}>
                <CustomLabel
                    value={item.name}
                    type='AVAILABLEUSED' />
                <View style={styles.verticalLine} />
                <SafeAreaView
                    style={styles.button}>
                    <CustomButton
                        iconName='pencil-outline'
                        onPress={() => {
                            editDocument(item)
                        }}
                        show='HOME_BELL'
                        type='HOME_BELL'
                        textTop='2'
                        sz={20} />

                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                //* Note: below styles do not seem to be working. Maybe investigate?
                                Swal.fire({
                                    title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:deleteDocMessage')}</text>`,
                                    icon: "warning",
                                    showCancelButton: true,
                                    reverseButtons: true,
                                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
                                    cancelButtonColor: '#d3d3d3',
                                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:remove')}</text>`,
                                    confirmButtonColor: '#A0A2FF',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        removeDocument(item);
                                    };
                                });
                            }
                        }}>
                        <View>
                            <Ionicons name="trash-outline" size={20} />
                        </View>
                    </TouchableOpacity>
                </SafeAreaView>
            </SafeAreaView >
        )
    }
    if (loading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    return (
        <SafeAreaView style={styles.mainView}>
            {selectedCompany !== null && !editDocumentScreen && !addNewDocument &&
                // addDocExist &&
                (
                    <View style={[styles.buttons, styles.functionalityButtons]}>
                        <CustomButton
                            onPress={() => {
                                setAddNewDocument(1);
                            }}
                            text={t('common:add')}
                            iconName="add-outline"
                            show="BUTTON_ADD"
                            type="BUTTON_ADD"
                            textTop="0"
                            sz={20}
                        />
                    </View>
                )}
            <FlatList
                data={documents}
                renderItem={renderItem}
                scrollEnabled={true}
                keyExtractor={(item) => item.id}
                refreshing={loading}
                ListHeaderComponent={
                    <SafeAreaView style={common.listTitle}>
                        <SafeAreaView style={styles.rowHeaders}>
                            <CustomLabel value={t("common:surveyname")} type="SUBTITLE" />
                            <View style={styles.verticalLine} />
                            <View style={styles.row}>
                                <CustomLabel
                                    value={t("common:documentFunctionality")}
                                    type="SUBTITLE"
                                />
                            </View>
                        </SafeAreaView>
                        <SafeAreaView style={common.divider} />
                    </SafeAreaView>
                }
                initialNumToRender={4}
            />

            {(selectedCompany === undefined || selectedCompany === null) &&
                showMessage({
                    message: t("common:chooseACompanyMessage"),
                    type: "warning",
                    duration: 10000,
                })}

            {addNewDocument ? (
                <SafeAreaView style={{ height: "100%" }}>
                    <AddNewDocumentScreen selectedCompany={selectedCompany} onBack={() => {
                        setAddNewDocument(false);
                    }} />
                </SafeAreaView>
            ) : (
                <></>
            )}

            {editDocumentScreen ? (
                <SafeAreaView style={{ height: "100%" }}>
                    <AddNewDocumentScreen
                        document={documentForEdit}
                        selectedCompany={selectedCompany}
                        onBack={() => {
                            setEditDocumentScreen(false);
                            setDocumentForEdit(null);
                        }}
                    />
                </SafeAreaView>
            ) : (
                <></>
            )}
        </SafeAreaView>
    );

}

const makeStyles = (colors, height, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        justifyContent: 'center'
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center'
    },
    rowHeaders: {
        flexDirection: "row",
        marginHorizontal: '1%',
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    verticalLine: {
        backgroundColor: colors.buttons_primary,
        height: '100%',
        width: 1,
    },
    functionalityButtons: {
        justifyContent: 'flex-end',
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginRight: 10,
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },

})